import { createAction } from '@reduxjs/toolkit';

import { EmailTemplate } from '../../types/entity.types';
import { SagaPayload } from '../api.types';
import { SaveEmailTemplatesRequest, TestEmailTemplateRequest, ViewEmailTemplatesRequest } from './email-template.types';

export const requestSaveEmailTemplates =
  createAction<SagaPayload<SaveEmailTemplatesRequest, EmailTemplate[]>['payload']>('request/saveEmailTemplates');

export const requestViewEmailTemplates =
  createAction<SagaPayload<ViewEmailTemplatesRequest, EmailTemplate[]>['payload']>('request/viewEmailTemplates');

export const requestTestEmailTemplate =
  createAction<SagaPayload<TestEmailTemplateRequest>['payload']>('request/testEmailTemplate');
